import PanelPeriodControl from "connected-components/dashboard/components/panel-period-control"
import { useGraphData } from "../hooks/use-graph-data"

interface GraphPanelPeriodControlProps {
  isPerformance?: boolean
}

export default function GraphPanelPeriodControl({ isPerformance = true }: GraphPanelPeriodControlProps) {
  const { dateOverride, setDateOverride, clearDateOverride, earliestDate, latestDate, startDate, endDate, isDateOverrideActive } = useGraphData()

  return (
    <PanelPeriodControl
      dates={{ earliestDate, latestDate, startDate, endDate }}
      dateOverride={dateOverride}
      isDateOverrideActive={isDateOverrideActive}
      setDateOverride={setDateOverride}
      clearDateOverride={clearDateOverride}
      isPerformance={isPerformance}
    />
  )
}
